/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState } from "react";
import CachedIcon from "@mui/icons-material/Cached";
import DynamicTable from "../dynamic_table/dynamic_table";

import PropTypes from "prop-types";

const HealthReportExportButton = () => {
  const handleExportClick = () => {
    document.querySelector("#client-page-header-download-health-report").click();
  };

  return (
    <button
      type="button"
      className="button is-primary is-outlined ccw-button"
      explorator_test_id="export-data-page-download-health-report"
      onClick={handleExportClick}
    >
      Export health card issues
    </button>
  );
};
const ExportButton = () => {
  return (
    <a
      href="/export_data_advanced"
      className="button is-primary ccw-button ccw-button--primary"
      explorator_test_id="export-data-page-advanced-export"
    >
      Create export
    </a>
  );
};
const RefreshButton = ({ onRefresh }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await onRefresh();
    setIsRefreshing(false);
  };

  return (
    <div className="ccw-operations-refresh">
      <button
        type="button"
        className="button ccw-button"
        explorator_test_id={"refresh-jobs-button"}
        disabled={isRefreshing}
        onClick={handleRefresh}
      >
        <CachedIcon aria-hidden="true" className={isRefreshing ? "spin" : ""} />
        {isRefreshing ? "Refreshing…" : "Refresh jobs"}
      </button>
    </div>
  );
};

RefreshButton.propTypes = {
  onRefresh: PropTypes.func.isRequired
};

const ExportDataView = () => {
  const [jobs, setJobs] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    next_page: 1,
    prev_page: 1
  });

  const fetchData = async (page = 1) => {
    try {
      const response = await fetch(`/export_data/tracking_jobs.json?page=${page}`);
      const data = await response.json();

      setJobs(data.jobs);
      setPagination({
        currentPage: data.pagination.current_page,
        totalPages: data.pagination.total_pages,
        next_page: data.pagination.next_page,
        prev_page: data.pagination.prev_page
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePageChange = (page) => {
    fetchData(page);
  };

  return (
    <div className="export_data_view_component ccw-operations-export-view">
      <div className="ccw-operations-section-heading ccw-operations-section-heading--jobs">
        <div>
          <p className="ccw-operations-eyebrow">Export jobs</p>
          <h2>Files in progress and ready</h2>
          <p>Completed files remain available here until they are removed.</p>
        </div>
        <RefreshButton onRefresh={fetchData} />
      </div>
      <div className="export_data_view_component_buttons ccw-operations-actions">
        <div className="export_data_view_component_buttons_left_menu">
          <ExportButton />
          <HealthReportExportButton />
        </div>
      </div>

      <div className="export-data-jobs ccw-operations-jobs" aria-live="polite">
        {jobs.length > 0 ? (
          <DynamicTable data={jobs} columns={JobsColumns} />
        ) : (
          <div className="ccw-empty-state">
            <strong>No export jobs yet</strong>
            <span>Create an export to begin preparing a downloadable file.</span>
          </div>
        )}
      </div>
      <nav className="pagination ccw-operations-pagination" aria-label="Export job pages">
        {pagination.prev_page && (
          <button
            type="button"
            className="pagination-previous"
            onClick={() => handlePageChange(pagination.prev_page)}
          >
            ‹ Prev
          </button>
        )}{" "}
        {pagination.next_page && (
          <button
            type="button"
            className="pagination-next"
            onClick={() => handlePageChange(pagination.next_page)}
          >
            Next ›
          </button>
        )}
        <ul className="pagination-list">
          {[...Array(pagination.totalPages).keys()].map((n) => (
            <li key={n + 1}>
              <button
                type="button"
                className={`pagination-link ${
                  pagination.currentPage === n + 1 ? "is-current" : ""
                }`}
                aria-current={pagination.currentPage === n + 1 ? "page" : undefined}
                onClick={() => handlePageChange(n + 1)}
              >
                {n + 1}
              </button>
            </li>
          ))}
          {pagination.currentPage < pagination.totalPages ? (
            <button
              type="button"
              className="pagination-link"
              onClick={() => handlePageChange(pagination.totalPages)}
            >
              {`Last »`}
            </button>
          ) : null}
        </ul>
      </nav>
    </div>
  );
};

const JobsColumns = ["Table Name", "Description", "Status", "Time used", "Created At"];

export default ExportDataView;
